import React, { memo, useEffect } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';

import { selectors } from 'src/store';
import Container from 'src/components/pages/Activities/TreasureHunt/Levels/Container';

const TreasureHuntLevels = ({
  currency,
  getLevelsByCollectionId,
  hasLoaded,
  student,
  groupOrderNumber,
  levels,
  ...props
}) => {
  useEffect(() => {
    getLevelsByCollectionId();
  }, [getLevelsByCollectionId]);

  return (
    <Container
      groupOrderNumber={groupOrderNumber}
      hasLoaded={hasLoaded}
      items={levels}
      currency={currency}
      student={student}
      {...props}
    />
  );
};

TreasureHuntLevels.propTypes = {
  currency: PropTypes.shape({}),
  getLevelsByCollectionId: PropTypes.func.isRequired,
  groupOrderNumber: PropTypes.number,
  hasLoaded: PropTypes.bool.isRequired,
  student: PropTypes.shape({}).isRequired,
  levels: PropTypes.arrayOf(PropTypes.shape({})),
};

TreasureHuntLevels.defaultProps = {
  currency: null,
  groupOrderNumber: 0,
  levels: [],
};

const mapStateToProps = (state) => ({
  hasLoaded: selectors.dailyMap.getHasLoadedLevels(state),
  groupOrderNumber: selectors.dailyMap.getDailyMapCollection(state)
    ?.groupOrderNumber,
  currency: selectors.dailyMap.getDailyMapCollection(state)?.currency,
  levels: selectors.dailyMap.getDailyMapCollection(state)?.levels,
  student: selectors.authentication.getStudent(state),
});

const mapDispatchToProps = {};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  memo
)(TreasureHuntLevels);
